module.exports = __webpack_public_path__ + "img/innovator-enthusiast-3.39dbe58a.svg";